// extracted by mini-css-extract-plugin
export var addToCartButton = "_r1-b";
export var arrowButtonContainer = "_r1-9";
export var arrowButtonIcon = "_r1-a";
export var carouselArrowButton = "_r1-6";
export var carouselElementContainer = "_r1-1";
export var left = "_r1-7";
export var productDisplayCarouselContainer = "_r1-0";
export var productTileContainer = "_r1-2";
export var productTileImage = "_r1-4";
export var productTileImageContainer = "_r1-3";
export var productTileTitle = "_r1-5";
export var right = "_r1-8";
export var sliderOverflow = "_r1-c";